<template>
	<div class="business-photo">
		<common-layout>
			<div slot="header">
				<h3>{{title}}</h3>
			</div>
			<div slot="container">
				<div class="business-photo.header">
					<el-button class="business-photo.addBtn" @click="$router.go(-1)">返回上一页</el-button>
					<el-button type="success" icon="el-icon-plus" @click="add" style="background: #623AA2; border: none;" v-show="tableData.length == 0">新增</el-button>
					<el-button type="success" icon="el-icon-edit" @click="editEvent"  v-show="tableData.length > 0">编辑</el-button>
				</div>
				<div class="business-photo.table" v-if="tableData.length > 0">
					<div class="item" v-for="(item,index) in tableData" :key="index">
						<el-card :body-style="{ padding: '0px' }">
							<img :src="item" class="image">
							<div style="padding: 10px;display: flex;flex-direction: column;">
								<span>{{obj.course_name}}</span>
								<time class="time">第{{obj.course_phase}}期</time>
								
							</div>
						</el-card>
					</div>
				</div>
				<div v-else>暂无数据</div>
			</div>
		</common-layout>
		<el-dialog title="往期剪影详情" :visible.sync="dialogVisible" width="60%" :close-on-click-modal='false' @closed="is_submit= true">
			<el-form :model="form" :rules="rules" ref="form">
				<el-row :gutter="30">
					<el-col :span="12">
						<el-form-item label="课程级别" label-width="80px" prop="course_id">
							<el-input v-model="form.course_name" placeholder="请填写课程级别" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="课程期数" label-width="80px" prop="course_phase">
							<el-input v-model="form.course_phase" placeholder="请填写课程期数" type="number" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="课程剪影" label-width="100px" prop="file">
					<el-upload style="width: 100%;display: flex;" :action="this.uploadURL" :file-list="form.file" list-type="picture-card"
					 :on-success="handleAvatarSuccess" :on-remove="handleRemove">
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="课程描述" label-width="80px" prop="phase_content">
					<el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="form.phase_content">
					</el-input>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import CommonLayout from '../../components/common-layout.vue'
	export default {
		components: {
			CommonLayout
		},
		data() {
			return {
				title:'',
				is_submit : true,
				operate:'add',
				   total: 20,
				   current_page: 1,
				   per_page: 10,
				dialogImageUrl: '',
				dialogVisible: false,
				tableData:[],
				obj:{},
				options:[],
				form: {
					course_name:'',
					course_id: '',
					course_phase: '',
					file: [],
					phase_content: ''
				},
				rules: {
					course_name: [{
						required: true,
						message: '请输入课程级别',
						trigger: 'blur'
					}],
					course_phase: [{
						required: true,
						message: '请输入课程期数',
						trigger: 'blur'
					}],
					file: [{
						required: true,
						message: '请输入课程级别',
						trigger: 'blur'
					}],
					phase_content: [{
						required: true,
						message: '请输入课程描述',
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			add(){
				this.dialogVisible = true
				this.operate = 'add'
			    setTimeout(()=>{
					this.$refs['form'].resetFields();
					this.form.course_id = this.obj.course_id;
					this.form.course_name = this.obj.course_name
					this.form.course_phase = this.obj.course_phase
					this.form.file = []
					
					
				},50)
			},
			handleCurrentChange(val){
				this.getDate(`Technology_Skill_Course_Phase&page=${val}`);
			},
			formatFile(files){
				let arrs = []
				files && files.split(",").forEach((item, index) => {
						arrs.push({
							name: "材料-" + (index + 1),
							url:  item
						});
				});
				return arrs
			},
			editEvent() {
				this.dialogVisible = true
				this.operate = 'edit'
				this.form.course_id = this.obj.course_id;
				this.form.course_name = this.obj.course_name
				this.form.course_phase = this.obj.course_phase
				this.form.file = this.formatFile(this.obj.src)
				this.form.phase_content = this.obj.phase_content
			},
			handleRemove(file, fileList, type) {
				this.form.file = fileList
			},

			handleAvatarSuccess(response, file, fileList) {
				if (response.code == 0) {
					this.form.file = fileList
				}
			},
			submit() {
				if(!this.is_submit) {
					return false
				}
				this.is_submit = false;
				this.$refs['form'].validate(valid => {
					if (valid) {
						let arr = [];
						this.form.file.forEach(item => {
							arr.push(item.size ? (this.imgUrl + item.response.data.store_result) : item.url)
						})
						
						let obj = {
							phase_content:this.form.phase_content,
							src:arr.join(',')
						}
                          this.http.put("Technology_Skill_Course_Phase/" + this.obj.id, obj).then(res => {
                          	if(res.code == 0){
                          		this.$message.success("编辑成功");
                          		this.dialogVisible = false;
                          		this.getData(`Technology_Skill_Course_Phase/${this.obj.id}`)
                          	} else {
								  this.is_submit = true;
							  }
                          })
					} else {
						this.is_submit = true
					}
				})
			},
			getData(url) {
				this.http.get(url).then(res => {
					if (res.code == 0) {
						this.title= res.data.course_name + '第' + res.data.course_phase + '期剪影';
						this.obj = res.data;
						this.tableData = res.data.src? res.data.src.split(',') : []
					} else {
						this.$message.error("获取数据失败！！");
					}
				});
			},
			
			resetForm() {
				this.$refs['form'].resetFields();
				this.dialogVisible = false;
			},
			deleteEvent(row) {
				this.$confirm("此操作将永久删除, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true
					})
					.then(() => {
						// this.http
						//   .request("Resource_Gain/" + row.id, "", "delete")
						//   .then(res => {
						//     if (res.code == 0) {
						//       this.getData("Resource_Gain?all=1&page=" + this.current_page);
						//       this.$message({
						//         type: "success",
						//         message: "删除成功"
						//       });
						//     } else {
						//       this.$message({
						//         message: "失败！",
						//         type: "error"
						//       });
						//     }
						//   });
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除"
						});
					});
			}
		},
		mounted() {
		    console.log(this.$route.query.id)	
			this.getData(`Technology_Skill_Course_Phase/${this.$route.query.id}`)
		}
	}
</script>

<style lang="scss">
	@include component(business-photo) {
		width: 100%;
		height: 100%;

		@include part(header) {
			display: flex;
			justify-content: flex-start;

			@include component(el-input) {
				width: 300px;
			}

			section {
				margin-left: 50px;
			}
		}

		@include part(searchBtn) {
			margin-left: 10px;
			margin-right: 30px;
		}

		@include part(addBtn) {
			margin-left: 30px;
		}

		@include part(table) {
			margin-top: 30px;
			display: flex;
			align-items: center;
			flex-wrap: wrap;

			.item {
				width: 230px;
				margin-right: 20px;
				margin-top: 20px;

			}

			.time {
				font-size: 13px;
				color: #999;
			}

			.bottom {
				display: flex;
				justify-content: center;
			}

			.image {
				width: 100%;
				height: 150px;
				display: block;
			}
		}
	}
</style>
